import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-landing-page-canone-stop',
  templateUrl: './landing-page-canone-stop.component.html',
  styleUrls: ['./landing-page-canone-stop.component.scss']
})
export class LandingPageCanoneStopComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landing-page-canone-stop/landing-page-canone-stop.component.ts